import GaEvent from './GaEvent';

export default class CtaClickedGaEvent extends GaEvent {
  constructor(name?: string) {
    super('cta_clicked');

    if (name) {
      this.addCtaName(name);
    }
  }
}
